export default "/b554e21ed8a659b822597c92967d1f4c2aa51bb5/a2cdf02300b2663230f496dbfe02b4a0.svg";